import PaymentCategories from '../../../../enums/PaymentCategories';
import getAvailableCategoriesToPaymentOptionsMap from './getAvailableCategoriesToPaymentOptionsMap';
import getIsInApmExperiment from './getIsInApmExperiment';
import getSelectedPaymentCategory from './getSelectedPaymentCategory';
import getShouldShowPaymentCategorySelectBoxes from './getShouldShowPaymentCategorySelectBoxes';

export default paymentOptionName => (state) => {
  const selectedPaymentCategory = getSelectedPaymentCategory(state);
  const availableCategoriesToPaymentOptionsMap = getAvailableCategoriesToPaymentOptionsMap(state);
  const shouldShowPaymentCategorySelectBoxes = getShouldShowPaymentCategorySelectBoxes(state);
  const isInApmExperiment = getIsInApmExperiment(state);
  
  if (!isInApmExperiment || !shouldShowPaymentCategorySelectBoxes) return false;
  
  if (!!selectedPaymentCategory && selectedPaymentCategory !== PaymentCategories.NONE) {
    const paymentOptionsForSelectedCategory = availableCategoriesToPaymentOptionsMap[selectedPaymentCategory] || [];
    if (paymentOptionsForSelectedCategory?.length > 0) {
      return !paymentOptionsForSelectedCategory.some(paymentOption => paymentOption.name === paymentOptionName);
    }
    
    // If theres no options for the selected category, show all options as a fallback
    return false;
  }
  
  // If in the apm experiment and selected category, hide all options.
  return true;
};
